import { render, staticRenderFns } from "./BodyPresetGridThumbnail.vue?vue&type=template&id=f6619a0e&scoped=true"
import script from "./BodyPresetGridThumbnail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BodyPresetGridThumbnail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BodyPresetGridThumbnail.vue?vue&type=style&index=0&id=f6619a0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6619a0e",
  null
  
)

export default component.exports